'use strict';

var interopRequireDefault = require('../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
require('./utils/registerCSSInterfaceWithDefaultTheme.js');
var registerCSSInterfaceWithDefaultTheme = require('../../../_virtual/registerCSSInterfaceWithDefaultTheme.js_commonjs-exports.js');

var _interopRequireDefault = interopRequireDefault;

var _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(registerCSSInterfaceWithDefaultTheme.__exports);

(0, _registerCSSInterfaceWithDefaultTheme["default"])();
